// Closing a bootstrap modal must never leave the page unusable.
//
// Every modal here is mounted on demand with v-if, so the element can be gone
// by the time bootstrap gets to hide it. When that happens `hide()` throws
// ("reading 'style'" on a backdrop it no longer has) half-way through, and
// the leftovers stay: a .modal-backdrop over everything and body.modal-open
// with overflow hidden. The page then looks completely normal and ignores
// every click — which is what "the editor froze" turned out to mean.

import { recordProblem } from "./problem-log";

export function safeHideModal(modal, label = "dialog") {
  try {
    modal?.hide();
  } catch (e) {
    recordProblem(
      "editor",
      `The ${label} could not be closed cleanly`,
      e?.message ?? String(e)
    );
  }
  clearModalLeftovers();
}

// Also worth running on unmount: whatever happened, the page must be usable.
export function clearModalLeftovers() {
  document
    .querySelectorAll(".modal-backdrop, .offcanvas-backdrop")
    .forEach((el) => el.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
}

// Bootstrap can close a dialog on its own — Escape, or a click outside one
// that is not static. The component around it is mounted with v-if on a
// `show` prop, and that prop knows nothing about it: the dialog disappears
// while the editor still believes it is open, so the button that opens it
// does nothing and the only way back is a page reload.
//
// Returns a function that unregisters the listener again.
export function onModalHidden(element, handler) {
  if (!element) {
    return () => {};
  }
  element.addEventListener("hidden.bs.modal", handler);
  return () => element.removeEventListener("hidden.bs.modal", handler);
}
